export default __webpack_public_path__ + "static/media/AfterPhoto3.e6fe1c71.jpg";